import {Outlet, useOutletContext} from "react-router";

export const AuditContainer = () => {
    const {filters, setFilters, navOptions, handleNavigate} = useOutletContext();

    return (
        <div style={{marginTop: 30, marginBottom: 100}}>
            <Outlet context={{filters, setFilters, navOptions, handleNavigate}}/>
        </div>
    );
};